import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import WebAPI from '../../api/webs';
import Vue from 'vue';
import {
  WEB_SOURCES_SORT_BY,
  SOURCES_SORT_ORDER,
} from '../../routes/dashboard/sources/constants';
export const state = {
  records: [],
  countQuestionsUnresolved: 0,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    stepGenerate: 0,
  },
  meta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
    sortOrder: SOURCES_SORT_ORDER.desc,
    sortBy: WEB_SOURCES_SORT_BY.updatedAt,
  },
  detailWeb: {},
  recordUrls: [],
  recordQuestions: [],
  recordQuestionsMeta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
    sortOrder: SOURCES_SORT_ORDER.desc,
    sortBy: WEB_SOURCES_SORT_BY.updatedAt,
  },
  recordUrlsMeta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
    sortOrder: SOURCES_SORT_ORDER.desc,
    sortBy: WEB_SOURCES_SORT_BY.updatedAt,
  },
};

export const getters = {
  getWebs($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getMeta: $state => {
    return $state.meta;
  },
  getWebUrls($state) {
    return $state.recordUrls;
  },
  getWebUrlsMeta($state) {
    return $state.recordUrlsMeta;
  },
  getWebQuestions($state) {
    return $state.recordQuestions;
  },
  getWebQuestionsMeta($state) {
    return $state.recordQuestionsMeta;
  },
  getCountQuestionsUnresolved($state) {
    return $state.countQuestionsUnresolved;
  },
  getWeb($state) {
    return $state.detailWeb;
  },
};

export const actions = {
  get: async ({ commit }, { page, perPage, sortBy, sortOrder }) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const {
        data: { resources, meta },
      } = await WebAPI.get(page, perPage, sortBy, sortOrder);
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      commit(types.default.SET_WEB_SOURCES, resources);
      commit(types.default.SET_WEB_SOURCES_META, {
        currentPage: meta.current_page,
        perPage: meta.per_page,
        totalEntries: meta.total,
      });
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    }
  },
  show: async ({ commit }, payload) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { data } = await WebAPI.show(payload.id);
      commit(types.default.SET_WEB_SOURCES_DETAIL, data);
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.default.SET_WEB_SOURCES_CREATING_STATUS, true);
    try {
      const { data } = await WebAPI.create(payload);
      const rs = state.records;
      rs.push(data)
      actions.refresh({ commit });

      commit(types.default.SET_WEB_SOURCES_CREATING_STATUS, false);
      commit(types.default.SET_WEB_SOURCES, rs);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_CREATING_STATUS, false);
      throw error;
    }
  },
  update: async ({ commit }, payload) => {
    commit(types.default.SET_WEB_SOURCES_UPDATING_STATUS, true);
    try {
      const { data } = await WebAPI.update(payload.id, {
        website: payload,
      });

      actions.refresh({ commit });
      let rs = state.records;
      rs.map(item => item.id === data.id ? data : item);
      commit(types.default.SET_WEB_SOURCES, rs);
      commit(types.default.SET_WEB_SOURCES_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_UPDATING_STATUS, false);
      throw new Error(error);
    }
  },
  delete: async ({ commit }, payload) => {
    commit(types.default.SET_WEB_SOURCES_DELETING_STATUS, true);
    try {
      await WebAPI.update(payload.id, {
        website: {
          url: payload.url,
          status: 'deleted',
        },
      });

      let rs = state.records;
      rs = rs.filter(r => r.id !== payload.id);

      commit(types.default.SET_WEB_SOURCES, rs);
      commit(types.default.SET_WEB_SOURCES_DELETING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_DELETING_STATUS, false);
      throw new Error(error);
    }
  },
  refresh: async ({ commit }) => {
    actions.get(
      { commit },
      {
        page: state.meta.currentPage,
        perPage: state.meta.perPage,
      }
    );
  },
  getWebUrls: async ({ commit }, { websiteId, page, perPage, sortBy, sortOrder }) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const {
        data: { resources, meta },
      } = await WebAPI.getURLs(websiteId, page, perPage, sortBy, sortOrder);

      commit(types.default.SET_WEB_SOURCES_URLS, resources);
      commit(types.default.SET_WEB_SOURCES_URLS_META, {
        currentPage: meta.current_page,
        perPage: meta.per_page,
        totalEntries: meta.total,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
  getWebQuestions: async ({ commit }, {
      websiteId,
      page = state.recordQuestionsMeta.currentPage,
      perPage = state.recordQuestionsMeta.perPage,
      sortBy = state.recordQuestionsMeta.sortBy,
      sortOrder = state.recordQuestionsMeta.sortOrder
  }) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const {
        data: { resources, meta, count_unresolved },
      } = await WebAPI.getQuestions(websiteId, page, perPage, sortBy, sortOrder);

      commit(types.default.SET_WEB_SOURCES_QUESTIONS, resources);
      commit(
        types.default.SET_QUESTION_SOURCES_COUNT_UNRESOLVED,
        count_unresolved
      );
      commit(types.default.SET_WEB_SOURCES_QUESTIONS_META, {
        currentPage: meta.current_page,
        perPage: meta.per_page,
        totalEntries: meta.total,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
  deleteWebUrl: async ({ commit },  payload ) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { isSuccess } = await WebAPI.deleteURL(payload.website_id, payload.website_page_id);
      let rs = state.recordUrls;
      rs = rs.filter(r => r.id !== payload.website_page_id);
      commit(types.default.SET_WEB_SOURCES_URLS, rs);
      commit(types.default.SET_WEB_SOURCES_URLS_META, {
        totalEntries: state.recordUrlsMeta.totalEntries - 1,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
  deleteWebQuestion: async ({ commit },  payload ) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { isSuccess } = await WebAPI.deleteQuestion(payload.website_id, payload.website_question_id);
      let rs = state.recordQuestions;
      rs = rs.filter(r => r.id !== payload.website_question_id);
      commit(types.default.SET_WEB_SOURCES_QUESTIONS, rs);
      commit(types.default.SET_WEB_SOURCES_QUESTIONS_META, {
        totalEntries: state.recordQuestionsMeta.totalEntries - 1,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
  deleteUrlResource: async ({ commit },  payload ) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { data } = await WebAPI.deleteUrlResource(payload.website_id, payload.website_page_ids);
      let rs = state.recordUrls;
      rs = rs.filter(r => ! payload.website_page_ids.includes(r.id));
      commit(types.default.SET_WEB_SOURCES_URLS, rs);
      commit(types.default.SET_WEB_SOURCES_URLS_META, {
        totalEntries: state.recordUrlsMeta.totalEntries - payload.website_page_ids.length,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      commit(types.default.SET_WEB_SOURCES_GENERATE_STEP, 0);
      throw error;
    }
  },
  deleteQuestionResource: async ({ commit },  payload ) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { data } = await WebAPI.deleteQuestionResource(payload.website_id, payload.website_question_ids);
      let rs = state.recordQuestions;
      rs = rs.filter(r => ! payload.website_question_ids.includes(r.id));
      commit(types.default.SET_WEB_SOURCES_QUESTIONS, rs);
      commit(types.default.SET_WEB_SOURCES_QUESTIONS_META, {
        totalEntries: state.recordQuestionsMeta.totalEntries - payload.website_question_ids.length,
      });
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      commit(types.default.SET_WEB_SOURCES_GENERATE_STEP, 0);
      throw error;
    }
  },
  generateQuestions: async ({ commit }, payload ) => {
    commit(types.default.SET_WEB_SOURCES_GENERATE_STEP, 1);
    try {
      const { isSuccess } = await WebAPI.generateQuestions(payload.website_id);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_GENERATE_STEP, 0);
      throw error;
    }
  },
  setGenerateStep: async ({ commit }, { step } ) => {
    commit(types.default.SET_WEB_SOURCES_GENERATE_STEP, step);
  },
  checkGeneratingStatus: async ({ commit }, payload ) => {
    commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, true);
    try {
      const { data: { status } } = await WebAPI.checkGeneratingStatus(payload.id);
      commit(types.default.SET_WEB_SOURCES_DETAIL, {...state.detailWeb, status: status});
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_WEB_SOURCES_FETCHING_STATUS, false);
      throw error;
    }
  },
};

export const mutations = {
  [types.default.SET_WEB_SOURCES_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_WEB_SOURCES_CREATING_STATUS]($state, status) {
    $state.uiFlags.isCreating = status;
  },
  [types.default.SET_WEB_SOURCES_UPDATING_STATUS]($state, status) {
    $state.uiFlags.isUpdating = status;
  },
  [types.default.SET_WEB_SOURCES_DELETING_STATUS]($state, status) {
    $state.uiFlags.isDeleting = status;
  },
  [types.default.SET_WEB_SOURCES_GENERATE_STEP]($state, step) {
    $state.uiFlags.stepGenerate = step;
  },

  [types.default.SET_WEB_SOURCES]: MutationHelpers.set,
  [types.default.ADD_WEB_SOURCES]: MutationHelpers.create,
  [types.default.EDIT_WEB_SOURCES]: MutationHelpers.update,
  [types.default.DELETE_WEB_SOURCES]: MutationHelpers.destroy,
  [types.default.SET_WEB_SOURCES_META]: ($state, data) => {
    const { totalEntries, currentPage } = data;
    Vue.set($state.meta, 'totalEntries', totalEntries);
    Vue.set($state.meta, 'currentPage', currentPage);
  },
  [types.default.SET_WEB_SOURCES_QUESTIONS_META]: ($state, data) => {
    const { totalEntries, currentPage } = data;
    Vue.set($state.recordQuestionsMeta, 'totalEntries', totalEntries);
    Vue.set($state.recordQuestionsMeta, 'currentPage', currentPage);
  },
  [types.default.SET_WEB_SOURCES_URLS_META]: ($state, data) => {
    const { totalEntries, currentPage } = data;
    Vue.set($state.recordUrlsMeta, 'totalEntries', totalEntries);
    Vue.set($state.recordUrlsMeta, 'currentPage', currentPage);
  },
  [types.default.SET_WEB_SOURCES_DETAIL]($state, data) {
    $state.detailWeb = data;
  },
  [types.default.SET_WEB_SOURCES_URLS]($state, data) {
    $state.recordUrls = data;
  },
  [types.default.SET_WEB_SOURCES_QUESTIONS]($state, data) {
    $state.recordQuestions = data;
  },
  [types.default.SET_QUESTION_SOURCES_COUNT_UNRESOLVED]($state, count) {
    $state.countQuestionsUnresolved = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
